module.exports = __webpack_public_path__ + "static/img/yytx21.b7430cb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/details/yytx21.png
// module id = 153
// module chunks = 0